export default "__VITE_ASSET__CI9X6gTu__"